import { notFound } from '@tanstack/react-router'
import type { RuntimeConfig } from '@/shared/config/schema'
import type { AppModule, Surface } from './types'

/** Intersects the static registry with `config.enabledModules`. Unknown ids are ignored. */
export function getEnabledModules(
  registry: readonly AppModule[],
  config: Pick<RuntimeConfig, 'enabledModules'>,
): AppModule[] {
  const enabled = new Set(config.enabledModules)
  return registry.filter((module) => enabled.has(module.id))
}

export function modulesForSurface(modules: readonly AppModule[], surface: Surface): AppModule[] {
  return modules.filter((module) => module.surface === surface)
}

/**
 * Route guard for `beforeLoad`: a disabled module renders the not-found page. Because this runs
 * before the (auto code-split) route component is loaded, the module's code is never fetched.
 */
export function requireModule(moduleId: string) {
  return ({ context }: { context: { services: { modules: readonly AppModule[] } } }): void => {
    if (!context.services.modules.some((module) => module.id === moduleId)) throw notFound()
  }
}
